module.exports = __webpack_public_path__ + "img/volume.689f4b47.png";